
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/r/[vanityUrl]",
      function () {
        return require("private-next-pages/r/[vanityUrl].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/r/[vanityUrl]"])
      });
    }
  